<template>
  <b-container>
    <b-row>
      <b-col
          cols="auto"
          class="pr-1 pl-0"
          v-if="index < 3"
          v-for="(item, index) in itemsLabel"
          :key="item ? item.id : index">
        {{ item || '' }}
        <span v-if="index < itemsLabel.length - 1">, </span>
      </b-col>

      <span v-if="items && items.length > 3">(+{{ items.length - 3 }})</span>
    </b-row>
  </b-container>
</template>

<script>
import FormsLoader from "@/components/forms/FormsLoader";
import FormsAI from "@/components/forms/FormsAI";
import RtModule from "@/utils/RtModule";

export default {
  name: "ListGrid",

  async created() {
    await this.refresh();
  },

  async mounted() {
    if (this.model?.__typename__) {
      let formConfig = FormsLoader.detectFormConfig(this.model.__typename__);
      this.$onUpdate(formConfig.formClassLong, async (changeEvent) => {
        if (changeEvent.id === this.model.id) {
          if (changeEvent.instance) {
            this.items = changeEvent.instance[this.prop] || [];
            await this.getValues();
          }
        }
      });

      this.$onBulkChange(formConfig.formClassLong, async (changeEvent) => {
        if (changeEvent.instance) {
          this.items = changeEvent.instance[this.prop] || [];
          await this.getValues();
        }
      });
    }
  },

  methods: {
    async getValues() {
      this.itemsLabel = [];
      if (this.items?.length) {
        let modelFormConfig = FormsLoader.detectFormConfig(this.model);
        let fieldConfig = modelFormConfig.fields.find(el => el.fieldName === this.prop) || null;

        if (fieldConfig?.gridToStringFunction) {
          const fun = RtModule()[fieldConfig.gridToStringFunction];
          if (fun) {
            this.itemsLabel.push(fun.call(this.formConfig, this.items, fieldConfig, this.formConfig));
            return;
          }
        }

        this.formConfig = FormsLoader.detectFormConfig(this.items[0]);
        for (let item of this.items) {
          if (item) {
            let res = await FormsAI.getEntityLabel(this.formConfig, item);
            if (res) {
              this.itemsLabel.push(res);
            }
          }
        }
      }
    },

    async refresh() {
      if (this.model && this.prop) {
        this.items = Array.isArray(this.model[this.prop]) ? this.model[this.prop] : [];
        await this.getValues();
      }
    }
  },

  watch: {
    model(val) {
      this.refresh();
    },
    prop(val) {
      this.refresh();
    }
  },

  props: ["rowIndex", "prop", "model", "column"],

  data: () => ({
    items: [],
    itemsLabel: [],
    formConfig: null,
  })
}
</script>
